const loadingLayer = () => {
 const CODE_LAYER = `
 <div class="layer-loading">
 <div class="inner">
 <div class="loader"></div>
 <span class="loader-label">데이터 조회중</span>
 </div>
 </div>
 `;

 const SELECTOR_LAYER = `.layer-loading`;

 const handleShow = () => {
 document
 .querySelectorAll(SELECTOR_LAYER)
 .forEach((layer) => layer.remove());

 const openDialog = document.querySelector(`dialog[open]`);
 const targetContainer = openDialog || document.body;

 targetContainer.insertAdjacentHTML(`beforeend`, CODE_LAYER);

 const loading = document.querySelector(SELECTOR_LAYER);

 loading && setTimeout(() => loading.classList.add(`active`), 10);
 };

 const handleHide = () => {
 document.querySelectorAll(SELECTOR_LAYER).forEach((layer) => {
 layer.classList.remove(`active`);
 setTimeout(() => layer.remove(), 150); // CSS transition duration
 });
 };

 // const initialize = () => {};

 // initialize();

 loadingLayer.show = handleShow;
 loadingLayer.hide = handleHide;

 // loadingLayer.cleanup = () => {};
};

export default loadingLayer;
